// Frontend twin of the backend's ensure_bw_group_suffix (analytics/utils.py).
// Since PRDDEV-61695 the product treats the bare platform location id and the
// BroadWorks group id (bare + "G") as two forms of the same location; the
// hierarchy endpoint serves LOCATION externalIds G-suffixed while
// /admin-groups/locations still serves bare locationIds. Canonicalizing BOTH
// sides of a comparison to the G form makes lookups format-agnostic (covers
// pre-61695 backends and selections stored before the change).
export const ensureBwGroupSuffix = (
  value: string | number | null | undefined,
): string => {
  if (value === null || value === undefined) return "";
  const str = String(value);
  if (!str) return "";
  return str.endsWith("G") ? str : `${str}G`;
};
